export { default as GenBanner } from './GenBanner';
export { default as CmsBanner } from './CmsBanner';
